import { FC } from 'react';
import { Tooltip } from 'antd';
import { SOverflowCount, SOverflowList, SVisibleItems } from './styles';

const DEFAULT_MAX_VISIBLE = 2;
const DEFAULT_SEPARATOR = ', ';

interface Props {
    items: string[];
    maxVisible?: number;
    separator?: string;
}

const OverflowList: FC<Props> = ({ items, maxVisible = DEFAULT_MAX_VISIBLE, separator = DEFAULT_SEPARATOR }) => {
    if (items.length === 0) return null;

    const visibleItems = items.slice(0, maxVisible);
    const hiddenItems = items.slice(maxVisible);
    const hasHiddenItems = hiddenItems.length > 0;

    return (
        <SOverflowList>
            {visibleItems.length > 0 && <SVisibleItems>{visibleItems.join(separator)}</SVisibleItems>}
            {hasHiddenItems && (
                <Tooltip title={hiddenItems.join(separator)}>
                    <SOverflowCount>+ {hiddenItems.length}</SOverflowCount>
                </Tooltip>
            )}
        </SOverflowList>
    );
};

export default OverflowList;
